<template>
    <FormControl
        required
        label="Name"
        :error="
            errors?.getValidationError(RequestBodyKeyEnum.App_Availability_Name)
        "
    >
        <TextInput
            :name="RequestBodyKeyEnum.App_Availability_Name"
            :value="availability.name"
            required
        />
    </FormControl>
    <FormControl
        required
        label="Timezone"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_Availability_TimeZone,
            )
        "
    >
        <TimezoneSelector
            :name="RequestBodyKeyEnum.App_Availability_TimeZone"
            :value="selectedTimezone"
            :useBookingFormThemeCssVariables="false"
            :required="true"
            @onTimezoneSelectionChange="
                (event) => (selectedTimezone = event.value)
            "
        />
    </FormControl>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import Availability from '@/App/Availability/Entity/Availability'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TimezoneSelector from '@/BookingForm/BookingForm/Component/TimezoneSelector.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        availability: {
            type: Object as PropType<Availability>,
            required: true,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })

    const selectedTimezone = ref<string>(props.availability.timeZone)
</script>
